import React from "react";
import { Status } from "../types";

interface StatusLabelProps {
  status: Status | null;
}

export const StatusLabel: React.FC<StatusLabelProps> = ({ status }) => {
  if (status === null) return null;

  const statusConfig: Record<Status, { text: string; className: string }> = {
    [Status.PendingPayment]: {
      text: "결제전",
      className: "text-[#555555] bg-[#F2F2F2]",
    },
    [Status.Accepted]: {
      text: "접수",
      className: "text-[#4285F4] bg-[#E8EFFF]",
    },
    [Status.Resubmission]: {
      text: "재접수",
      className: "text-[#4285F4] bg-[#E8EFFF]",
    },
    [Status.Production]: {
      text: "제작",
      className: "text-[#4285F4] bg-[#E8EFFF]",
    },
    [Status.ProductionComplete]: {
      text: "제작 완료",
      className: "text-[#4285F4] bg-[#E8EFFF]",
    },
    [Status.Shipping]: {
      text: "출고/배송",
      className: "text-[#29B43F] bg-[#DFF8E4]",
    },
    [Status.Delivered]: {
      text: "배송 완료",
      className: "text-[#1B5E20] bg-[#C8E6C9]",
    },
    [Status.Cancelled]: {
      text: "취소",
      className: "text-[#555555] bg-[#F2F2F2]",
    },
    [Status.Refunded]: {
      text: "환불",
      className: "text-[#E53935] bg-[#FFEBEE]",
    },
  };

  const config = statusConfig[status];
  if (!config) return null;

  return (
    <div
      className={`text-center rounded-[4px] py-[1px] px-[6px] font-medium size-max ${config.className}`}
    >
      {config.text}
    </div>
  );
};
